<template>
  <b-tabs>
    <b-tab-item label="All Encrypted Treasures">
      <div class="columns is-multiline is-mobile">
        <div
          class="column is-2-desktop is-6-mobile"
          v-for="element in nonSpeedUpElements"
          :key="element.id"
        >
          <Element :element="element"></Element>
        </div>
      </div>
    </b-tab-item>
    <b-tab-item label="Treasure MiningXP Elements">
      <div class="columns is-multiline is-mobile">
        <div
          class="column is-2-desktop is-6-mobile"
          v-for="element in speedUpElements"
          :key="element.id"
        >
          <Element :element="element"></Element>
        </div>
      </div>
    </b-tab-item>
    <b-tab-item label="Treasure Miner">
      <div class="columns is-multiline is-mobile">
        <div
          class="column is-6-desktop is-12-mobile"
          v-for="factory in factories"
          :key="factory.id"
        >
          <Factory :factory="factory"></Factory>
        </div>
      </div>
    </b-tab-item>
  </b-tabs>
</template>
<script>
import Element from "@/components/Element";
import Factory from "@/components/Factory";
import contract from "./../Utils/Contract.js";

export default {
  components: { Element, Factory },
  data() {
    return {};
  },
  computed: {
    factories: function() {
      return contract.factories;
    },
    elements: function() {
      return contract.elements;
    },
    speedUpElements: function() {
      return contract.elements.filter(element => element.isSpeedUp);
    },
    nonSpeedUpElements: function() {
      return contract.elements.filter(element => !element.isSpeedUp);
    }
  }
};
</script>
